<template>
  <div>
    <div>
      {{teams[affiliatedTeam.id].name}}
      <template v-if="
      teams[affiliatedTeam.id].part.job.length > 0 ||
      teams[affiliatedTeam.id].part.range.length > 0 ||
      teams[affiliatedTeam.id].part.custom.length > 0">
        팀의,
        <el-select v-model="affiliatedTeam.part"
                   size="mini"
                   placeholder="파트 선택"
                   @change="makeSelectRowViewData(copiedMember)">
          <el-option-group v-for="(part, type) in teams[affiliatedTeam.id].part"
                           :key="type"
                           :label="type">
            <el-option v-for="category in part"
                       :key="category"
                       :label="category"
                       :value="category">
            </el-option>
          </el-option-group>
        </el-select>파트 에서
      </template>

      <template v-else>
        팀에서
      </template>

      <template v-if="!teams[affiliatedTeam.id].is_division">
        <!--사용자는 팀의 모든 사이트를 담당 한다.-->
      </template>
      <template v-else>
        <el-select v-model="affiliatedTeam.division"
                   size="mini"
                   multiple
                   placeholder="Select"
                   @change="makeSelectRowViewData(copiedMember)">
          <el-option
            v-for="item in teams[affiliatedTeam.id].division"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>의
      </template>

      <el-select v-model="affiliatedTeam.job"
                 size="mini"
                 multiple
                 placeholder="업무 선택"
                 @change="makeSelectRowViewData(copiedMember)">
        <template v-if="copiedMember.occupation.length === 0">
          <el-option v-for="(job, jobId) in jobs"
                     :key="jobId"
                     :label="job.name"
                     :value="job.id">
          </el-option>
        </template>
        <template v-else>
          <el-option v-for="(job, jobId) in jobs"
                     v-if="affiliatedTeam.part === jobId"
                     :key="jobId"
                     :label="job.name"
                     :value="job.id">
          </el-option>
          <el-option v-for="(job, jobId) in jobs"
                     v-if="copiedMember.occupation.includes(job.category)"
                     :key="jobId"
                     :label="job.name"
                     :value="job.id">
          </el-option>
        </template>

      </el-select>업무를 수행

    </div>


    <div>
      <el-button @click="handleEditException"
                 size="mini"
                 type="warning">예외사항 처리</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateTeam from '@/components/CreateTeam';
import filterTeamView from '@/filters/getTeamViewData';
import filterJobView from '@/filters/getJobViewData';

import getClassNameByException from '@/filters/getClassNameByException';

export default {
  props: [
    'copiedMember',
    'affiliatedTeam',
  ],
  filters: {
    getClassNameByException,
    filterTeamView,
    filterJobView,
  },
  components: {
    CreateTeam,
  },
  computed: {
    ...mapGetters([
      'members',
      'groups',
      'services',
      'jobs',
      'teams',
    ]),
  },
  methods: {
    getClass(facility) {
      return getClassNameByException(facility);
    },
    handleEditException() {
      this.dialogVisible = true;
    },

  },
  data() {
    return {
      name: 'EditAffiliatedTeam',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EditAffiliatedTeam.vue